import { sprintf } from 'sprintf-js';
import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

const URLS = {
  USERS: '/org/%s/admin/users/',
  USER: '/org/%s/admin/users/%s/',
  INVITE_USER: '/org/%s/admin/users/invite/',
  UPDATE_USER: '/org/%s/admin/users/%s/',
};

export const organizationUsers = {
  getOrganizationUsers: ({
    organizationCodename,
    params,
  }: {
    organizationCodename: string;
    params?: SearchParamsType;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.USERS, organizationCodename),
      params: {
        ...params,
      },
    }),
  getOrganizationUser: ({
    organizationCodename,
    userId,
  }: {
    organizationCodename: string;
    userId: number | string | null;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.USER, organizationCodename, userId),
    }),
  inviteUserToOrganization: ({
    organizationCodename,
    data,
  }: {
    organizationCodename: string;
    data: {
      email: string;
      organization_role: number | string;
      org_groups: (string | number)[] | null;
    };
  }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.INVITE_USER, organizationCodename),
      data: {
        email: data.email,
        organization_role: data.organization_role,
        org_groups: data.org_groups,
      },
    }),
  updateUserInOrganization: ({
    organizationCodename,
    userId,
    data,
  }: {
    organizationCodename: string;
    userId: number;
    data: {
      email?: string;
      organization_role?: number | string;
      org_groups?: (string | number)[] | null;
      shared_projects?: (string | number)[];
      shared_products?: (string | number)[];
    };
  }) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.UPDATE_USER, organizationCodename, userId),
      data: {
        organization_role: data.organization_role,
        user: {
          ...data,
        },
      },
    }),
  updateUserActiveState: ({
    organizationCodename,
    userId,
    isActive,
  }: {
    organizationCodename: string;
    userId: number;
    isActive: boolean;
  }) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.UPDATE_USER, organizationCodename, userId),
      data: {
        is_active: isActive,
      },
    }),
  deleteeUserFromOrganization: ({
    organizationCodename,
    userId,
  }: {
    organizationCodename: string;
    userId: number;
  }) =>
    apiInstance.request({
      method: 'DELETE',
      url: sprintf(URLS.UPDATE_USER, organizationCodename, userId),
    }),
  assignUserToGroup: ({
    organizationCodename,
    userId,
    data,
  }: {
    organizationCodename: string;
    userId: number;
    data: {
      email: string;
      role: number;
      groups: string[];
    };
  }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.UPDATE_USER, organizationCodename, userId),
      data: data,
    }),
};
